import React from 'react';
import {Header,Item, Label,  Breadcrumb, Table, Transition, Icon, Segment, Container, Loader, Dropdown, Divider, Form, Dimmer, Button, Grid,Input, Radio, Popup, List} from 'semantic-ui-react';
import { Link } from "react-router-dom";
import moment from 'moment';
import { DatePicker, Space } from 'antd';
//import "antd/dist/antd.css";
import dayjs from 'dayjs';
import locale from 'antd/es/date-picker/locale/es_ES';
const dateFormat = 'DD/MM/YYYY';


const ReporteCurso=({ id, ajaxCallInProgress, errors=[],reporte, cambiarEstatus, datos, strings, cursoCombo, onChange, download, constancia, resultadosExamen, onShowAvance, onSave, onBuscar,usuario, estatusCombo, tipoPagoCombo,busqueda, fechas,usuarioCombo, tipomonedaCombo})=>{


    
	return (
        <Container>
			<Grid container>
                <Grid.Row>
                    <Grid.Column >
                        <Form  >          
                            <Form.Field  required  error={errors.idUsaurio}>            
                              <label  >{strings?strings["mail"]:""}</label>
                              <Input 
                                    placeholder={strings?strings["mail"]:""} 
                                    name="busqueda"
                                    onChange={onChange}
                                    value={busqueda}
                                    icon='edit'/>
        
                                <br/><br/>
                                <Button  color="black"
                                    onClick={onBuscar}>{strings?strings["buscar"]:""}
								 </Button>    
        
                            </Form.Field>
        
                            {usuario.id>0?
        
                                <Container>
        
                                    <Table>
                                        <Table.Header>
                                            <Table.Row>
                                            <Table.HeaderCell>{strings?strings["nombre"]:""}</Table.HeaderCell>
                                            <Table.HeaderCell>{strings?strings["empresa"]:""}</Table.HeaderCell>
                                            <Table.HeaderCell textAlign="center">{strings?strings["telefono"]:""}</Table.HeaderCell>
                                            </Table.Row>
                                        </Table.Header>
                                        <Table.Body>
                                            <Table.Row>
                                            <Table.Cell>{usuario.nombre+" "+usuario.apellido}</Table.Cell>
                                            <Table.Cell>{usuario.empresa}</Table.Cell>
                                            <Table.Cell textAlign="center">{usuario.telefono}</Table.Cell>
                                            </Table.Row>
                                        </Table.Body>
                                    </Table>
        
                                    <Form.Field  required  error={errors.idUsuarioVentas}>
                                      <label  >{strings?strings["idUsuarioVentas"]:""}</label>
                                      <Dropdown 
                                            placeholder={strings?strings["idUsuarioVentas"]:""} 
                                            name="idUsuarioVendedor"
                                             fluid 
                                            search 
                                            selection
                                            onChange={onChange}
                                            value={datos.idUsuarioVendedor}
                                            options={usuarioCombo}/>
                                    </Form.Field>
        
        
                                    <Form.Field  required  error={errors.idEstatus}>
                                      <label  >{strings?strings["estatusId"]:""}</label>
                                      <Dropdown 
                                            placeholder={strings?strings["estatusId"]:""} 
                                            name="idEstatus"
                                             fluid 
                                            search 
                                            selection
                                            onChange={onChange}
                                            value={datos.idEstatus}
                                            options={estatusCombo}/>
                                    </Form.Field>
        
                                    
                                    <Form.Field  required  error={errors.idTipoPago}>
                                      <label  >{strings?strings["tipoPagoId"]:""}</label>
                                      <Dropdown 
                                            placeholder={strings?strings["tipoPagoId"]:""} 
                                            name="idTipoPago"
                                             fluid 
                                            search 
                                            selection
                                            onChange={onChange}
                                            value={datos.idTipoPago}
                                            options={tipoPagoCombo}/>
                                    </Form.Field>
        
                                     <Form.Field required>
                                        <label>{strings?strings["fechaPago"]:""}</label>  
                                        <DatePicker bordered={false}
                                                defaultValue={dayjs(datos.fechaInicio, dateFormat)}    
                                                onChange={(dates, dateStrings)=>fechas(dates, dateStrings)} 
                                                locale={locale} 
                                                size="large" 
                                                value={dayjs(datos.fechaInicio, dateFormat)}
                                                allowClear={false}
                                                format={dateFormat} />
                                    </Form.Field>
                                                
                                                
                                                



                                    <Form.Field  required  error={errors.noCuotas}>            
                                      <label  >{strings?strings["noCuotas"]:""}</label>
                                      <Input 
                                            placeholder={strings?strings["noCuotas"]:""} 
                                            name="noCuotas"
                                            onChange={onChange}
                                            value={datos.noCuotas}
                                            icon='edit'/>
                                    </Form.Field>
                                            
                                            
                                            

                                    <Form.Field  required  error={errors.idTipoMoneda}>
                                      <label  >{strings?strings["idTipoMoneda"]:""}</label>
                                      <Dropdown 
                                            placeholder={strings?strings["idTipoMoneda"]:""} 
                                            name="idTipoMoneda"
                                             fluid 
                                            search 
                                            selection
                                            onChange={onChange}
                                            value={datos.idTipoMoneda}
                                            options={tipomonedaCombo}/>
                                    </Form.Field>            
                                    
                                      

                                     <Form.Field  required  error={errors.costoCurso}>            
                                      <label  >{strings?strings["costoCurso"]:""}</label>
                                      <Input 
                                            placeholder={strings?strings["costoCurso"]:""} 
                                            name="costoCurso"
                                            value={datos.costoCurso}
                                            icon='edit'/>

                                    </Form.Field>
                                            
                                    
                                    <Form.Field  required  error={errors.descuento}>            
                                      <label  >{strings?strings["descuento"]:""}</label>
                                      <Input 
                                            placeholder={strings?strings["descuento"]:""} 
                                            name="descuento"
                                            onChange={onChange}
                                            value={datos.descuento}
                                            icon='edit'/>

                                    </Form.Field>              

                                    
                                    <Form.Field  required  error={errors.costoTotal}>            
                                      <label  >{strings?strings["costoTotal"]:""}</label>
                                      <Input 
                                            placeholder={strings?strings["costoTotal"]:""} 
                                            name="costoTotal"
                                            value={datos.costoTotal}
                                            icon='edit'/>

                                    </Form.Field>        
                                            
                                            
                                    <Form.Field  required  error={errors.costoPagado}>            
                                      <label  >{strings?strings["costoPagado"]:""}</label>
                                      <Input 
                                            placeholder={strings?strings["costoPagado"]:""} 
                                            name="costoPagado"
                                            onChange={onChange}
                                            value={datos.costoPagado}
                                            icon='edit'/>

                                    </Form.Field>

                                    <Divider hidden/>
                                      <Grid centered>
                                    <Button.Group  >
                                        <Link to="/inscripcion">
                                            <Button  
                                                >{strings?strings["regresar"]:""}</Button>
                                        </Link>
                                        <Button.Or text=" "></Button.Or>
                                        <Button  color="black"
                                            onClick={onSave}>{strings?strings["guardar"]:""}
                                         </Button>
                                      </Button.Group>
                                    </Grid>
                                   <br/>

        
                                </Container>
                                :
        
                                ""
                
                            }
                        
                            
                        </Form>
                    </Grid.Column>
                </Grid.Row>
                
            
            </Grid>
        
        
        </Container>
	);
};



export default ReporteCurso;